import React, { memo } from 'react';
import PropTypes from 'prop-types';

import Style from './InfoSettingsButton.module.less';

import Fab from '@mui/material/Fab';
import { Settings } from '@mui/icons-material';

const InfoSettingsButton = (props: InfoSettingsButton.propTypes) => {
  return (
    <div className={Style.Root}>
      <Fab size="small" onClick={props.onClick}>
        <Settings />
      </Fab>
    </div>
  );
};

InfoSettingsButton.propTypes = {
  onClick: PropTypes.func,
};

export default memo(InfoSettingsButton);
